import { useEffect, useState } from "react";
import { getFilterData } from "../../../../Api/Api";

// Distinct batteryConfigList.cellChemistry values for the org. The backend drops NULLs;
// blank strings are dropped here.
export const CELL_CHEMISTRY_FILTER_CONFIG = {
  type: "dynamic",
  queryParams: {
    table: "batteryConfigList",
    column: "cellChemistry",
  },
};

/**
 * Clean the getFilterData rows into a sorted, de-duplicated list of chemistry names.
 * @param {Array<{id: *}>} filterData - res.response.response.filterData
 * @returns {string[]}
 */
export function parseCellChemistryOptions(filterData) {
  if (!Array.isArray(filterData)) return [];
  const names = filterData
    .map((row) => (row?.id == null ? "" : String(row.id).trim()))
    .filter(Boolean);
  return [...new Set(names)].sort((a, b) => a.localeCompare(b));
}

/**
 * The quick filter is only useful when there is a real choice to make: with one
 * chemistry, "All" and that chemistry show almost the same fleet.
 * @param {string[]} options
 * @returns {boolean}
 */
export function shouldShowCellChemistryFilter(options) {
  return Array.isArray(options) && options.length >= 2;
}

/**
 * v2/list `filters` entries for the selected chemistry. null means All: no entry is
 * sent, so batteries with no chemistry recorded stay in the count.
 * @param {string|null} cellChemistry
 * @returns {Array<{name: string, value: string[]}>}
 */
export function buildCellChemistryFilters(cellChemistry) {
  return cellChemistry ? [{ name: "cellChemistry", value: [cellChemistry] }] : [];
}

/** Fetch the chemistry options once per mount. */
export function useCellChemistryOptions() {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    let cancelled = false;
    getFilterData(CELL_CHEMISTRY_FILTER_CONFIG)
      .then((res) => {
        if (!cancelled) setOptions(parseCellChemistryOptions(res?.response?.response?.filterData));
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => { cancelled = true; };
  }, []);
  return options;
}
